import {
  AspectRatio,
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  HStack,
  Stack,
  Text,
  Wrap,
} from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { Calendar, Download } from "react-feather";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchDownloadLink } from "../../api/lucroVault";

export const VideoPlayerPage = ({
  resourceData,
  setVault,
  isWorkshop,
  fullData,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const formRef = useRef(null);

  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const clearQueryString = () => {
    navigate(location.pathname);
    setVault(false);
  };

  useEffect(() => {
    if (isWorkshop) {
      const script = document.createElement("script");
      script.src = "https://api.waitlistworkshops.com/js/form_embed.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [isWorkshop]);

  return (
    <Stack p={"24px 24px 24px 32px"}>
      <Wrap>
        <Text
          fontSize={"16px"}
          fontWeight={400}
          color={"#2D3748"}
          onClick={clearQueryString}
          cursor={"pointer"}
          _hover={{
            textDecoration: "underline",
            textDecorationColor: "#2D3748",
          }}
        >
          Growth Tools
        </Text>
        <Text fontSize={"16px"} fontWeight={400} color={"#1A202C"}>
          {">"}
        </Text>
        {isWorkshop && (
          <>
            <Text
              fontSize={"16px"}
              fontWeight={400}
              color={"#2D3748"}
              onClick={() => {
                setVault(false);

                const params = new URLSearchParams(location.search);
                params.delete("stepId");
                navigate({ search: params.toString() });
              }}
              cursor={"pointer"}
              _hover={{
                textDecoration: "underline",
                textDecorationColor: "#2D3748",
              }}
            >
              {fullData?.resource_title}
            </Text>
            <Text fontSize={"16px"} fontWeight={400} color={"#1A202C"}>
              {">"}
            </Text>
          </>
        )}

        <Text fontSize={"16px"} fontWeight={700} color={"#2D3748"}>
          {resourceData?.resource_title}
        </Text>
      </Wrap>
      <HStack spacing={1} flexWrap="wrap" mt={"24px"}>
        {(fullData?.tags || resourceData?.tags || []).map((tag) => (
          <Box
            key={tag.id}
            backgroundColor={tag.label_color}
            fontFamily="Lato"
            borderRadius="40px"
            display="inline-flex"
            alignItems="center"
            height="28px"
            px="10px"
            fontWeight={"700"}
          >
            <Text fontSize="15px">{tag.name}</Text>
          </Box>
        ))}

        {resourceData?.video_duration && resourceData?.external_link && (
          <HStack spacing={1}>
            <Box fontSize="17px" color="#4A5568">
              •
            </Box>
            <Box
              fontSize="17px"
              color="#4A5568"
              fontWeight={500}
              fontFamily="Lato"
            >
              {`${resourceData?.video_duration} min watch`}
            </Box>
          </HStack>
        )}
      </HStack>
      <Flex
        mt="8px"
        align="center"
        justify="space-between"
        width="100%"
        flexWrap={"wrap"}
        mb={"10px"}
      >
        <Text
          color="#1A202C"
          fontFamily="Poppins"
          fontWeight={600}
          fontSize="25px"
        >
          {resourceData?.resource_title}
        </Text>
        {isWorkshop && (
          <Button
            backgroundColor="#536DEC"
            borderRadius="6px"
            display="inline-flex"
            alignItems="center"
            height="36px"
            px="10px"
            onClick={scrollToForm}
          >
            <HStack spacing="6px" align="center">
              <Calendar size="15px" color="white" />
              <Text
                fontSize="16px"
                fontWeight={600}
                color="white"
                fontFamily="Poppins"
              >
                Schedule Free Demo Call
              </Text>
            </HStack>
          </Button>
        )}
        {(resourceData?.resource_file || resourceData?.resource_link) && !isWorkshop && (
          <Button
            backgroundColor="#536DEC"
            borderRadius="6px"
            display="inline-flex"
            alignItems="center"
            height="36px"
            px="10px"
            onClick={async () => {
              try {
                if (
                  resourceData.resource_type === "external" &&
                  resourceData.resource_link
                ) {
                  window.open(resourceData.resource_link, "_blank");
                } else {
                  const response = await fetchDownloadLink(resourceData?.id);
                  const fileUrl = response?.url;

                  if (fileUrl) {
                    window.open(fileUrl, "_blank");
                  } else {
                    console.error("No URL returned in response");
                  }
                }
              } catch (error) {
                console.error("Error fetching download URL", error);
              }
            }}
          >
            <HStack spacing="6px" align="center">
              <Download size="15px" color="white" />
              <Text
                fontSize="16px"
                fontWeight={600}
                color="white"
                fontFamily="Poppins"
              >
                Download Handout
              </Text>
            </HStack>
          </Button>
        )}
      </Flex>
      <Card mt={"4px"} borderRadius={"16px"}>
        <CardHeader padding={0}>
          <Box borderTopRadius="0px" overflow="hidden">
            <AspectRatio ratio={16 / 9}>
              <iframe
                src={resourceData?.external_link}
                allowFullScreen
                style={{
                  borderRadius: "12px 12px 0 0 ",
                }}
                title={resourceData?.resource_title}
              />
            </AspectRatio>
          </Box>
        </CardHeader>

        <CardBody
          padding={"24px"}
          ref={formRef}
          style={{ scrollMarginTop: "60px" }}
        >
          {isWorkshop ? (
            <Box
              w="100%"
              paddingX={"10%"}
              textAlign={"center"}
              alignItems={"center"}
              display={"flex"}
              flexDirection={"column"}
              spacing={"10px"}
            >
              <Box
                bgColor={"#E3EDFF"}
                p={"3px 10px"}
                mb={"10px"}
                w={"120px"}
                borderRadius={"4px"}
                height={"26px"}
              >
                <Text
                  fontWeight={500}
                  fontSize={"13px"}
                  color={"#536DEC"}
                  fontFamily="Poppins"
                >
                  Free Demo Call
                </Text>
              </Box>
              <Text
                fontWeight={600}
                fontSize={"22px"}
                mb={"10px"}
                fontFamily="Poppins"
              >
                Don’t Just Read About It, Experience It!
              </Text>
              <iframe
                src="https://api.waitlistworkshops.com/widget/booking/P8fenaE0Cior8zpHTVOn?paddingTop=40"
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "790px",
                  border: "none",
                  overflow: "hidden",
                }}
                title="Demo call organiser"
              />
              <script
                src="https://api.waitlistworkshops.com/js/form_embed.js"
                type="text/javascript"
              />
            </Box>
          ) : (
            <Box
              w="100%"
              pt={"10px"}
              paddingX={"20px"}
              textAlign={"left"}
              alignItems={"center"}
              display={"flex"}
              flexDirection={"column"}
              spacing={"10px"}
            >
              <Box
                textAlign={"center"}
                bgColor={"#E3EDFF"}
                p={"3px 10px"}
                mb={"5px"}
                w={"120px"}
                borderRadius={"4px"}
                height={"26px"}
              >
                <Text
                  fontWeight={500}
                  fontSize={"13px"}
                  color={"#536DEC"}
                  fontFamily="Poppins"
                >
                  Recap
                </Text>
              </Box>
              <Text fontWeight={600} fontSize={"22px"} fontFamily="Poppins">
                Here’s What We Covered
              </Text>
              <Text mt={"12px"} fontSize={"16px"} fontWeight={400}>
                {resourceData?.resource_description}
              </Text>
            </Box>
          )}
        </CardBody>
      </Card>
    </Stack>
  );
};
